import EmptyState from "@/components/EmptyState";
import SectionHeading from "@/components/SectionHeading";
import { CareerGoalsDetail } from "./_CareerGoalsDetail";
import type { CareerPlanGoal } from "./careerPlanHistory";

export default function CareerGoalsTab({
  goals,
  isLatest = false,
  onCreate,
  onEdit
}: {
  goals: CareerPlanGoal[];
  isLatest?: boolean;
  onCreate?: () => void;
  onEdit?: () => void;
}) {
  if (goals.length === 0) {
    return (
      <EmptyState
        title="No Career Goals"
        iconName="track_changes"
        caption={
          isLatest
            ? "No current Career Goals are saved for this person."
            : "No Career Goals were active for this snapshot."
        }
        {...(onCreate
          ? {
              action: {
                children: "Create Career Goals",
                onClick: onCreate,
                icon: "add",
                testId: "career-goals-create-empty"
              }
            }
          : {})}
      />
    );
  }

  return (
    <div className="flex flex-col gap-6" data-testid="career-plan-goals-tab">
      <SectionHeading
        heading="Career Goals"
        body="Details for this person's Career Plan snapshot."
        actions={
          onEdit
            ? [
                {
                  label: "Edit",
                  variant: "outlined",
                  onClick: onEdit,
                  testId: "career-goals-edit"
                }
              ]
            : []
        }
      />
      {goals.map((goal) => (
        <CareerGoalsDetail key={goal.id} goal={goal} />
      ))}
    </div>
  );
}
